import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Imports dynamiques pour éviter les problèmes de types
import fr from './locales/fr.json';
import en from './locales/en.json';
//import ar from './locales/ar.json';

const resources = {
    fr: { translation: fr },
    en: { translation: en },
    //ar: { translation: ar }
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'fr',
        lng: 'fr',
        interpolation: { escapeValue: false },
        detection: {
            order: ['localStorage', 'navigator', 'htmlTag'],
            caches: ['localStorage']
        }
    });

export default i18n;